var url = "http://47.122.118.209:8083/";
var imageUrl = "http://47.122.118.209/images/";
/* var url="http://192.168.31.43:8083/"; */

export {
  url,
  imageUrl,
}



// WEBPACK FOOTER //
// ./src/api/config.js